import AntragsuebersichtTable from "./AntragsuebersichtTable/AntragsuebersichtTable.vue";
import AntragsuebersichtGrafik from "./AntragsuebersichtGrafik/AntragsuebersichtGrafik.vue";

export default {
  AntragsuebersichtTable,
  AntragsuebersichtGrafik,
};
